<template>
  <Navbar></Navbar>
  <div class="about-page">
    <div class="about-first">
      <div class="about-kv-t1">
        FINEST Manufacturing
      </div>
      <div class="about-video-list">
        <div class="about-video-item" @click="clickFullVideo('/assets/about/1-1-full.mp4')">
          <div class="img-box">
            <video src="/assets/about/1-1.mp4" alt="" muted="muted" loop autoplay playsinline webkit-playsinline="true"
              x5-video-player-type="h5" x5-video-player-fullscreen="true" t7-video-player-type="inline"></video>
          </div>
          <div class="about-video-bottom">
            <div class="about-video-title">
              Engine Factory
            </div>
            <img src="/assets/about/play.png" alt="" class="about-video-play" />
          </div>
        </div>

        <div class="about-video-item" @click="clickFullVideo('/assets/about/1-2-full.mp4')">
          <div class="img-box">
            <video src="/assets/about/1-2.mp4" alt="" muted="muted" loop autoplay playsinline webkit-playsinline="true"
              x5-video-player-type="h5" x5-video-player-fullscreen="true" t7-video-player-type="inline"></video>
          </div>
          <div class="about-video-bottom">
            <div class="about-video-title">
              Transmission Factory
            </div>
            <img src="/assets/about/play.png" alt="" class="about-video-play" />
          </div>
        </div>

        <div class="about-video-item" @click="clickFullVideo('/assets/about/1-3-full.mp4')">
          <div class="img-box">
            <video src="/assets/about/1-3.mp4" alt="" muted="muted" loop autoplay playsinline webkit-playsinline="true"
              x5-video-player-type="h5" x5-video-player-fullscreen="true" t7-video-player-type="inline"></video>
          </div>
          <div class="about-video-bottom">
            <div class="about-video-title">
              Electronics Factory
            </div>
            <img src="/assets/about/play.png" alt="" class="about-video-play" />
          </div>
        </div>

      </div>
    </div>
    <div class="about-full-video" v-show="isFullVideo">
      <div class="img-box">
        <video class="pc-pad" :src="fullVideo" alt="" muted="muted" loop autoplay playsinline webkit-playsinline="true"
          x5-video-player-type="h5" x5-video-player-fullscreen="true"></video>
        <video class="mb-only" :src="fullVideo" alt="" muted="muted" loop autoplay playsinline webkit-playsinline="true"
          x5-video-player-type="h5" x5-video-player-fullscreen="true" t7-video-player-type="inline"></video>
      </div>
      <div class="about-full-video-close" @click="closeFullVideo()">
        <img class="pc-pad" src="/assets/about/close.png" alt="">
        <img class="mb-only" src="/assets/manufacture/close-m.png" alt=""></img>
      </div>

    </div>
    <div class="about-map-box">
      <div class="img-box img-box-height">
        <img class="pc-pad" src="/assets/manufacture/map-en.jpg" alt="">
        <img class="mb-only" src="/assets/manufacture/map-m.jpg" alt="">
      </div>

      <div class="map-detail-box" v-show="isClickMapAnchor">
        <div class="map-detail-d">
          <div class="img-box map-detail-left">
            <img :src="isPc ? mapHoverBoxs1.img : mapHoverBoxs1.imgM" alt="">
          </div>
          <div class="map-detail-right">
            <div class="map-right-top">
              <div class="map-detail-name">
                {{ mapHoverBoxs1.name }}
              </div>

              <div class="map-detail-address">
                <img src="/assets/contact/address-icon.png" alt=""></img>
                <span v-html="mapHoverBoxs1.address">

                </span>
              </div>

            </div>

            <div class="map-right-bottom" v-html="mapHoverBoxs1.detail"></div>

          </div>

        </div>
        <div class="map-detail-icon" @click="closeMapAnchor">
          <img src="/assets/about/close.png" alt="">
        </div>


      </div>
      <div class="about-map-layout about-map-item">
        <div class="about-map-text" >
          <div class="about-map-title">
            Global Factories
          </div>
          <div class="about-map-btn-list" v-if="!isPc">
            <div class="about-map-btn" :class="mapHoverBoxs2 == 1 ? 'active' : ''" @click=" mapHoverBoxs2 = 1">
              <div style="background: #E70012;"></div>
              Engine Factory
            </div>
            <div class="about-map-btn" :class="mapHoverBoxs2 == 2 ? 'active' : ''" @click=" mapHoverBoxs2 = 2">
              <div style="background: #57C0BF;"></div>
              Transmission Factory
            </div>
            <div class="about-map-btn" :class="mapHoverBoxs2 == 3 ? 'active' : ''" @click=" mapHoverBoxs2 = 3">
              <div style="background: #0F65B5;"></div>
              Electronics Factory
            </div>

          </div>

        </div>

        <!-- 7个 -->
        <!-- 保定 -->
        <div class="map-hover-box map-hover-box7 " v-if="isPc || mapHoverBoxs2 == 2" @click="clickMapAnchor(3)">
          <div class="map-hover-box-content lt">
            <div class="map-hover-box-title" style="transform: translateY(-50%);" >
              FINEST Transmission Technology (Hebei) Co., Ltd. Xushui Branch
            </div>
            <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="50,50 25,4 0,4" fill="none" stroke="#000" stroke-width="1" />
            </svg>
          </div>
        </div>
        <div class="map-hover-box map-hover-box3 " v-if="mapHoverBoxs2 == 1" @click="clickMapAnchor(7)">
          <div class="map-hover-box-content lt">
            <div class="map-hover-box-title">
              Engine Xushui Factory
            </div>
            <svg width="50" height="30" viewBox="0 0 50 30" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="50,30 25,4 0,4" fill="none" stroke="#000" stroke-width="1" />
            </svg>
          </div>
        </div>
        <div class="map-hover-box map-hover-box8 " v-if="mapHoverBoxs2 == 1" @click="clickMapAnchor(9)">
          <div class="map-hover-box-content lt">
            <div class="map-hover-box-title">
              Engine Dingxing Factory
            </div>
            <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="50,50 25,4 0,4" fill="none" stroke="#000" stroke-width="1" />
            </svg>
          </div>
        </div>
        <div class="map-hover-box map-hover-box9 " v-if="isPc || mapHoverBoxs2 == 3" @click="clickMapAnchor(14)">
          <div class="map-hover-box-content lb">
            <div class="map-hover-box-title">
              Zhangjiagang Factory
            </div>
            <svg width="50" height="30" viewBox="0 0 50 30" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="50,0 25,26 0,26" fill="none" stroke="#000" stroke-width="1" />
            </svg>
          </div>
        </div>
        <!-- 天津 -->
        <div class="map-hover-box map-hover-box10 " v-if="mapHoverBoxs2 == 1" @click="clickMapAnchor(6)">
          <div class="map-hover-box-content rt">
            <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="0,50 25,4 50,4  " fill="none" stroke="#000" stroke-width="1" />
            </svg>
            <div class="map-hover-box-title">
              Engine Tianjin Factory
            </div>
          </div>
        </div>
        <div class="map-hover-box map-hover-box11" v-if="isPc || mapHoverBoxs2 == 3" @click="clickMapAnchor(15)">
          <div class="map-hover-box-content rt">
            <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="0,50 25,4 50,4  " fill="none" stroke="#000" stroke-width="1" />
            </svg>
            <div class="map-hover-box-title">
              Changshu Factory
            </div>
          </div>
        </div>

        <div class="map-hover-box map-hover-box12 " v-if="isPc || mapHoverBoxs2 == 2" @click="clickMapAnchor(1)">
          <div class="map-hover-box-content rb">
            <svg width="50" height="30" viewBox="0 0 50 30" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="0,0 25,26 50,26  " fill="none" stroke="#000" stroke-width="1" />
            </svg>
            <div class="map-hover-box-title">
              FINEST iMove Transmission Systems (Jiangsu) Co., Ltd.
            </div>
          </div>
        </div>
        <div class="map-hover-box map-hover-box2 " v-if="mapHoverBoxs2 == 1" @click="clickMapAnchor(5)">
          <div class="map-hover-box-content rt">
            <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="0,50 25,4 50,4  " fill="none" stroke="#000" stroke-width="1" />
            </svg>
            <div class="map-hover-box-title">
              FINEST Engine System（Jiangsu）Co., Ltd.
            </div>
          </div>
        </div>

        <div class="map-hover-box map-hover-box13" v-if="isPc || mapHoverBoxs2 == 3" @click="clickMapAnchor(16)">
          <div class="map-hover-box-content lt">
            <div class="map-hover-box-title">
              Wuxi Factory
            </div>
            <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="50,50 25,4 0,4" fill="none" stroke="#000" stroke-width="1" />
            </svg>
          </div>
        </div>

        <div class="map-hover-box map-hover-box15 " v-if="isPc || mapHoverBoxs2 == 2" @click="clickMapAnchor(0)">
          <div class="map-hover-box-content lt">
            <div class="map-hover-box-title" style="transform: translateY(-50%);">
              FINEST Transmission Technology (Chongqing) Co., Ltd.
            </div>
            <svg width="50" height="30" viewBox="0 0 50 30" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="50,30 25,4 0,4" fill="none" stroke="#000" stroke-width="1" />
            </svg>
          </div>
        </div>
        <div class="map-hover-box map-hover-box5 " v-if="mapHoverBoxs2 == 1" @click="clickMapAnchor(8)">

          <div class="map-hover-box-content lb">
            <div class="map-hover-box-title">
              FINEST Engine System（Chongqing）Co., Ltd.
            </div>
            <svg width="50" height="30" viewBox="0 0 50 30" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="50,0 25,26 0,26" fill="none" stroke="#000" stroke-width="1" />
            </svg>
          </div>
        </div>
        <div class="map-hover-box map-hover-box4 " v-if="mapHoverBoxs2 == 1" @click="clickMapAnchor(10)">
          <div class="map-hover-box-content lt">
            <div class="map-hover-box-title">
              FINEST auto Power System (Hubei) Co., Ltd.
            </div>
            <svg width="50" height="30" viewBox="0 0 50 30" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="50,30 25,4 0,4" fill="none" stroke="#000" stroke-width="1" />
            </svg>
          </div>
        </div>

        <div class="map-hover-box map-hover-box16" v-if="mapHoverBoxs2 == 1" @click="clickMapAnchor(12)">
          <div class="map-hover-box-content rb">
            <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="0,0 25,46 50,46  " fill="none" stroke="#000" stroke-width="1" />
            </svg>
            <div class="map-hover-box-title">
              FINEST Powertrain Systems (Jiangxi) Co., Ltd.
            </div>
          </div>
        </div>

        <div class="map-hover-box map-hover-box17 " v-if="mapHoverBoxs2 == 1" @click="clickMapAnchor(11)">
          <div class="map-hover-box-content lb">
            <div class="map-hover-box-title">
              FINEST Engine System（Thailand）Co., Ltd.
            </div>
            <svg width="50" height="30" viewBox="0 0 50 30" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="50,0 25,26 0,26" fill="none" stroke="#000" stroke-width="1" />
            </svg>
          </div>
        </div>

        <div class="map-hover-box map-hover-box18" v-if="isPc || mapHoverBoxs2 == 2" @click="clickMapAnchor(4)">
          <div class="map-hover-box-content lb">
            <div class="map-hover-box-title">
              FINEST Transmission Systems (Jiangsu) Co., Ltd.
            </div>
            <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="50,0 25,49 0,49" fill="none" stroke="#000" stroke-width="1" />
            </svg>
          </div>
        </div>
        <div class="map-hover-box map-hover-box1" v-if="mapHoverBoxs2 == 1" @click="clickMapAnchor(13)">
          <div class="map-hover-box-content rb">
            <svg width="50" height="30" viewBox="0 0 50 30" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="0,0 25,26 50,26  " fill="none" stroke="#000" stroke-width="1" />
            </svg>
            <div class="map-hover-box-title">
              FINEST V-Leader Power Technology（Jiangsu）Co.,Ltd.
            </div>
          </div>
        </div>


        <div class="map-hover-box map-hover-box19" v-if="isPc || mapHoverBoxs2 == 2" @click="clickMapAnchor(2)">
          <div class="map-hover-box-content rt">
            <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" class="map-line-lt">
              <polyline points="0,50 25,4 50,4  " fill="none" stroke="#000" stroke-width="1" />
            </svg>
            <div class="map-hover-box-title" >
              FINEST Transmission Technology Pizhou Co., Ltd.
            </div>
          </div>
        </div>
        <div class="map-hover-box map-hover-box6" v-if="mapHoverBoxs2 == 1">
        </div>




      </div>
    </div>
  </div>
  <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, nextTick, onUnmounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';
const swiperRefs = ref(null);
const swiperInstances = ref([]);

const hoverItemRefs = ref(1);

const mapHoverBoxs = ref(1);
const mapHoverBoxs2 = ref(1);

const fullVideo = ref('')
const isFullVideo = ref(false);

const isPc = ref(window.innerWidth > 768);

const hoverListDeatil = ref([
  {
    name: 'FINEST Transmission Technology (Chongqing) Co., Ltd.',
    img: '/assets/manufacture/bevel/8.png',
    imgM: '/assets/manufacture/bevel/8-m.jpg',
    address: 'Yongchuan District, Chongqing',
    detail: 'Located in Yongchuan District, Chongqing, the factory covers an area of 67,000 m² with a planned annual production capacity of 250,000 units, mainly manufacturing 9AT and 9HAT transmissions. It has introduced high-end international equipment from Germany, including Gleason, Präwema, Pfauter, Junkers and Felsomat, laying a solid foundation for precision manufacturing through micrometer-level craftsmanship. The factory deeply integrates MES digital management, RFID full-process traceability, real-time NVH monitoring, high-precision closed-loop inspection and AI visual error-proofing technologies, paired with automated robotic production lines. This enables full-process intelligent error prevention and process traceability from material feeding to final assembly, ensuring stable and reliable product quality via end-to-end digital management.'
  }, {
    name: 'FINEST iMove Transmission Systems (Jiangsu) Co., Ltd.',
    img: '/assets/manufacture/bevel/13.png',
    imgM: '/assets/manufacture/bevel/13-m.jpg',
    address: 'Taizhou City, Jiangsu Province',
    detail: 'Located in Taizhou City, Jiangsu Province, the factory covers an area of 12,000 m² with a planned capacity: 500,000 units per year for hydraulic module and dual-clutch module assembly respectively, and 250,000 units per year for dual-clutch module housings. It mainly manufactures hydraulic modules, dual-clutch modules and their housings. It has introduced high-end international equipment from Germany (GROB, THYSSENKRUPP, KUKA) and Switzerland (ABB), laying a solid foundation for precision manufacturing through micrometer-level craftsmanship. The factory deeply integrates full-functional performance bench testing, 100% automated bench verification, MES digital management and AI visual error-proofing technologies, paired with automated robotic production lines. This enables full-process intelligent error prevention and process traceability from material feeding to final assembly, ensuring stable and reliable product quality via end-to-end digital management.'
  }, {
    name: 'FINEST Transmission Technology Pizhou Co., Ltd.',
    img: '/assets/manufacture/bevel/3.png',
    imgM: '/assets/manufacture/bevel/3-m.jpg',
    address: 'Pizhou City, Jiangsu Province',
    detail: 'Located in Pizhou City, Jiangsu Province, the factory covers an area of 291,800 m² with a planned annual production capacity of 600,000 units, mainly manufacturing DHT-1, DHT-2, DHT-3, DHT-3L and 150kW pure electric drive assemblies. It has introduced high-end international equipment from Germany (GROB, Zeiss) and Switzerland (ABB), laying a solid foundation for precision manufacturing through micrometer-level craftsmanship. The factory deeply integrates Discom test systems, 3D precision inspection, laser marking traceability and AI visual error-proofing technologies, paired with automated robotic production lines. This enables full-process intelligent error prevention and process traceability from material feeding to final assembly, ensuring stable and reliable product quality via end-to-end digital management.'
  }, {
    name: 'FINEST Transmission Technology (Hebei) Co., Ltd. Xushui Branch',
    img: '/assets/manufacture/bevel/16.png',
    imgM: '/assets/manufacture/bevel/16-m.jpg',
    address: 'Xushui District, Baoding <br> City, Hebei Province',
    detail: 'Located in Xushui District, Baoding City, Hebei Province, the factory covers an area of 145,000 m² with a planned annual production capacity of 1.2 million units, mainly manufacturing 7DCT, 150kW and 200kW pure electric drive assemblies. It has introduced high-end international equipment from Germany, including GROB, PILLER, Weisser, Gleason and Profinoroll, laying a solid foundation for precision manufacturing through micrometer-level craftsmanship. The factory deeply integrates Discom test systems, full-functional assembly performance verification and AI visual error-proofing technologies, paired with automated robotic production lines. This enables full-process intelligent error prevention and process traceability from material feeding to final assembly, ensuring stable and reliable product quality via end-to-end digital management.'
  }, {
    name: 'FINEST Transmission Systems (Jiangsu) Co., Ltd.',
    img: '/assets/manufacture/bevel/12.png',
    imgM: '/assets/manufacture/bevel/12-m.jpg',
    address: 'Yangzhong City, Jiangsu Province',
    detail: 'Located in Yangzhong City, Jiangsu Province, the factory covers an area of 220,000 m² with a planned annual production capacity of 600,000 units, mainly manufacturing hybrid and new energy transmission products such as DHT, 9DCT and 135kW pure electric drive systems.It has introduced 108 sets of high-end international equipment from Germany, including SW, Weisser, Gleason, Profinoroll and ALD, laying a solid foundation for precision manufacturing through micrometer-level craftsmanship. The factory deeply integrates high-precision machining processes, real-time NVH monitoring, intelligent electronic control, high-definition sensor detection and AI visual error-proofing technologies, paired with automated robot assembly lines and fully automatic stator/rotor production lines. This enables full-process intelligent error prevention and process traceability from material feeding to final assembly, ensuring stable and reliable product quality via end-to-end digital management.'
  }, {
    name: 'FINEST Engine System（Jiangsu）Co., Ltd.',
    img: '/assets/manufacture/bevel/5.png',
    imgM: '/assets/manufacture/bevel/5-m.jpg',
    address: 'Yangzhong City, Jiangsu Province',
    detail: 'Located in Yangzhong City, Jiangsu Province, the factory covers an area of 120,000 m² with a planned annual production capacity of 400,000 units, mainly manufacturing 1.5L and 2.0L engines.<br>It has introduced high-end international equipment from Germany, including GROB, Nagel, HELLER, KUKA/FANUC, and MAG, laying a solid foundation for high-end manufacturing through micrometer-level craftsmanship. The factory deeply integrates MES digital systems, IoT, high-precision visual scanning, and AI visual error-proofing technologies, paired with automated robotic production lines. This enables full-process intelligent error prevention and process traceability from material feeding to final assembly, ensuring stable and reliable product quality via end-to-end digital management.'
  }, {
    name: 'Engine Tianjin Factory',
    img: '/assets/manufacture/bevel/15.png',
    imgM: '/assets/manufacture/bevel/15-m.jpg',
    address: 'Binhai New Area, Tianjin',
    detail: 'Located in Binhai New Area, Tianjin, the factory covers an area of 50,000 m² with a planned annual production capacity of 420,000 units, mainly manufacturing 1.5L engines.It has introduced high-end international equipment from Japan (Makino, HORKOS, Komatsu) and Germany (Nagel, LARU), laying a solid foundation for precision manufacturing through micrometer-level craftsmanship. The factory deeply integrates Artis monitoring, Marposs in-line measurement, intelligent sensing, and AI visual error-proofing technologies, paired with automated robotic production lines. This enables full-process intelligent error prevention and process traceability from material feeding to final assembly, ensuring stable and reliable product quality via end-to-end digital management.'
  }, {
    name: 'Engine Xushui Factory',
    img: '/assets/manufacture/bevel/17.png',
    imgM: '/assets/manufacture/bevel/17-m.jpg',
    address: 'Xushui District, Baoding City, Hebei Province',
    detail: 'Located in Xushui District, Baoding City, Hebei Province, the factory covers an area of 67,000 m² with a planned annual production capacity of 600,000 units, mainly manufacturing 1.5L and 2.0L engines.It has introduced high-end international equipment from Germany, including GROB, Nagel, and Junkers, laying a solid foundation for precision manufacturing through micrometer-level craftsmanship. The factory deeply integrates MES digital management, Marposs in-line measurement, one-code full-process traceability, and AI visual error-proofing technologies, paired with automated robotic production lines. This enables full-process intelligent error prevention and process traceability from material feeding to final assembly, ensuring stable and reliable product quality via end-to-end digital management.'
  }, {
    name: 'FINEST Engine System（Chongqing）Co., Ltd.',
    img: '/assets/manufacture/bevel/8.png',
    imgM: '/assets/manufacture/bevel/8-m.jpg',
    address: 'Yongchuan District, Chongqing',
    detail: 'Located in Yongchuan District, Chongqing, the factory covers an area of 42,000 m² with a planned annual production capacity of 220,000 units, mainly manufacturing 2.0L, 2.4L and 3.0L engines.It has introduced high-end international equipment from Japan (Makino, Mazak) and Germany (Nagel, Junkers), laying a solid foundation for precision manufacturing through micrometer-level craftsmanship. The factory deeply integrates RFID full-lifecycle traceability, 2D/3D precision inspection and AI visual error-proofing technologies, paired with automated robotic production lines. This enables full-process intelligent error prevention and process traceability from material feeding to final assembly, ensuring stable and reliable product quality via end-to-end digital management.'
  }, {
    name: 'Engine Dingxing Factory',
    img: '/assets/manufacture/bevel/4.png',
    imgM: '/assets/manufacture/bevel/4-m.jpg',
    address: 'Dingxing, Baoding City, Hebei Province',
    detail: 'Located in Dingxing, Baoding City, Hebei Province, the factory covers an area of 230,000 m² with a planned annual production capacity of 200,000 units, mainly manufacturing 2.0L diesel engines and 491QE gasoline engines.It has introduced high-end international equipment from the UK (Landis) and Germany (DMG), laying a solid foundation for precision manufacturing through micrometer-level craftsmanship. The factory deeply integrates full-operating-condition hot testing of complete engines, real-time process monitoring and traceability, and AI visual error-proofing technologies, paired with automated robotic production lines. This enables full-process intelligent error prevention and process traceability from material feeding to final assembly, ensuring stable and reliable product quality via end-to-end digital management.'
  }, {
    name: 'FINEST auto Power System (Hubei) Co., Ltd.',
    img: '/assets/manufacture/bevel/2.png',
    imgM: '/assets/manufacture/bevel/2-m.jpg',
    address: 'Daye City, Hubei Province',
    detail: 'Located in Daye City, Hubei Province, the plant covers an area of 107,000 m² with a planned annual production capacity of 150,000 units, mainly manufacturing 2.0L engines.It has introduced high-end international equipment from Germany (GROB, HELLER) and Switzerland (ABB, Kistler), laying a solid foundation for precision manufacturing through micrometer-level craftsmanship. The plant deeply integrates micrometer-level precision inspection, automated glue dispensing & oil injection, and AI visual error-proofing technologies, paired with automated robotic production lines. This enables full-process intelligent error prevention and process traceability from material feeding to final assembly, ensuring stable and reliable product quality via end-to-end digital management.'
  }, {
    name: 'FINEST Engine System（Thailand）Co., Ltd.',
    img: '/assets/manufacture/bevel/6.png',
    imgM: '/assets/manufacture/bevel/6-m.jpg',
    address: 'Ratchaburi, Thailand',
    detail: 'Located in Ratchaburi, Thailand, the plant covers an area of 42,000 m² with a planned annual capacity of 130,000 units for assembly lines and 100,000 pieces for crankshaft production lines, mainly manufacturing 1.5L, 2.0L, 2.4L and 3.0L engines and core components.It has introduced high-end international equipment from Japan (KEYENCE) and Switzerland (ABB), laying a solid foundation for precision manufacturing through micrometer-level craftsmanship. The plant deeply integrates heat treatment processes, laser precision visual inspection, full-lifecycle quality control and AI visual error-proofing technologies, paired with automated robotic production lines. This enables full-process intelligent error prevention and process traceability from material feeding to final assembly, ensuring stable and reliable product quality via end-to-end digital management.'
  }, {
    name: 'FINEST Engine System（Jiangxi）Co., Ltd.',
    img: '/assets/manufacture/bevel/7.png',
    imgM: '/assets/manufacture/bevel/7-m.jpg',
    address: 'Shangrao City, Jiangxi Province',
    detail: 'Located in Shangrao City, Jiangxi Province, the plant covers an area of 80,000 m² with a planned annual production capacity of 300,000 units, mainly manufacturing 1.5L and 2.0L engines.It has introduced high-end international equipment from Germany (KUKA, Siemens, Rexroth) and Japan (KEYENCE), laying a solid foundation for precision manufacturing through micrometer-level craftsmanship. The plant deeply integrates micrometer-level precision positioning, MES digital management, intelligent calibration and AI visual error-proofing technologies, paired with automated robotic production lines. This enables full-process intelligent error prevention and process traceability from material feeding to final assembly, ensuring stable and reliable product quality via end-to-end digital management.'
  }, {
    name: 'FINEST V-Leader Power Technology（Jiangsu）Co.,Ltd.',
    img: '/assets/manufacture/bevel/14.png',
    imgM: '/assets/manufacture/bevel/14-m.jpg',
    address: 'Taizhou City, Jiangsu Province',
    detail: 'Located in Taizhou City, Jiangsu Province, the factory covers an area of 20,000 m², mainly manufacturing turbochargers, hydrogen fuel cell air compressors, hydrogen circulation pumps and other turbomachinery products.It has introduced high-end international equipment from Italy (CEMB), Germany (Schenck) and the UK (CVE), laying a solid foundation for precision manufacturing through micrometer-level craftsmanship. The factory deeply integrates MES digital management, laser line scan & 3D imaging inspection, and AI visual error-proofing technologies, paired with automated robotic production lines. This enables full-process intelligent error prevention and process traceability from material feeding to final assembly, ensuring stable and reliable product quality via end-to-end digital management.'
  }, {
    name: 'Zhangjiagang Factory',
    img: '/assets/manufacture/bevel/9.png',
    imgM: '/assets/manufacture/bevel/9-m.jpg',
    address: 'Zhangjiagang City, Jiangsu Province',
    detail: 'Located in Zhangjiagang City, Jiangsu Province, the factory covers an area of 14,800 m² with a planned annual production capacity of 3 million pieces, mainly manufacturing cockpit domain controllers and driving domain controllers.It has introduced high-end international equipment from Germany (Siemens), Japan (Okuma, XRAY) and the United States (Keysight), laying a solid foundation for precision manufacturing through micrometer-level craftsmanship. The factory deeply integrates precision SMT soldering technology, full-process EOL performance testing, precision non-destructive testing and AI visual error-proofing technologies, paired with intelligent line automation control.  It has built a Class 300,000 clean production environment, enabling full-process production sequence control and comprehensive intelligent error prevention, ensuring stable and reliable product quality.'
  }, {
    name: 'Changshu Factory',
    img: '/assets/manufacture/bevel/10.png',
    imgM: '/assets/manufacture/bevel/10-m.jpg',
    address: 'Changshu City, Jiangsu Province',
    detail: 'Located in Changshu City, Jiangsu Province, the factory covers an area of 36,000 m² with a planned annual production capacity of 3.8 million pieces, mainly manufacturing display screens and power amplifiers. It has introduced high-end international equipment from Germany (Siemens, ERSA) and Japan (Panasonic, AOI), laying a solid foundation for precision manufacturing through micrometer-level craftsmanship. The factory deeply integrates precision electronic manufacturing processes, AOI optical inspection, full-process sequence verification and AI visual error-proofing technologies, paired with intelligent line automation control. It promotes the construction of "lights-out factories" and builds a classified clean production system of Class 1,000, Class 10,000 and Class 100,000, enabling full-process production sequence control and comprehensive intelligent error prevention, ensuring stable and reliable product quality.'
  }, {
    name: 'Wuxi Factory',
    img: '/assets/manufacture/bevel/11.png',
    imgM: '/assets/manufacture/bevel/11-m.jpg',
    address: 'Wuxi City, Jiangsu Province',
    detail: 'Located in Wuxi City, Jiangsu Province, the factory covers an area of 30,000 m² with a planned annual production capacity of 1.2 million sets, mainly manufacturing plastic-encapsulated IGBT, plastic-encapsulated SiC, gel-encapsulated IGBT and gel-encapsulated SiC. It has introduced high-end international equipment from Germany (ASM, Hesse, Pink) and the Netherlands (Boschman, BESI), laying a solid foundation for precision manufacturing through micrometer-level craftsmanship. The factory deeply integrates chip silver sintering, copper wire bonding, precision plastic encapsulation molding, finished product precision inspection and AI visual error-proofing technologies, paired with intelligent line automation control. This enables full-process production sequence control and comprehensive intelligent error prevention, ensuring stable and reliable product quality.'
  }
])

const mapHoverBoxs1 = ref('');
const isClickMapAnchor = ref(false);


// 点击全屏播放视频
// 点击全屏播放视频
const clickFullVideo = (item) => {
  fullVideo.value = item;
  isFullVideo.value = true;
  $('body').css('overflow', 'hidden');
  $('body').css('height', '100vh');

  // 正确写法：获取原生 DOM 元素再调用 play()
  nextTick(() => {
    const $videos = $('.about-full-video video');
    $videos.each(function () {
      this.play().catch(err => {
        console.warn('视频播放失败:', err);
      });
    });
  });
};

const closeFullVideo = () => {
  fullVideo.value = '';
  isFullVideo.value = false;
  $('body').css('overflow', 'auto');
  $('body').css('height', 'auto');

  const $videos = $('.about-full-video video');
  $videos.each(function () {
    this.pause();
    this.currentTime = 0; // 重置播放位置
  });
};

// 地图锚点点击
const clickMapAnchor = (item) => {
  mapHoverBoxs1.value = hoverListDeatil.value[item];
  isClickMapAnchor.value = true;
}
const closeMapAnchor = () => {
  mapHoverBoxs1.value = '';
  isClickMapAnchor.value = false;
}


const initAllSwipers = async () => {
  await nextTick();
  const el = swiperRefs.value;
  if (el) {
    const swiper = new Swiper(el, {
      // loop: true,
      speed: 1300,
      slidesPerView: 3,
      spaceBetween: 20,
      pagination: {
        el: el.querySelector(".swiper-pagination"),
        clickable: true,
      },
      direction: "horizontal",
      simulateTouch: true,
      breakpoints: {
        768: {
        },
        1024: {
        }
      },
      on: {
        init: function () {
        },
        slideChangeTransitionStart(swiper) {
          let swiperIndex = swiper.realIndex;
        },
      },
    });
    swiperInstances.value.push(swiper);
  }
};
onMounted(() => {
  initAllSwipers()
})

</script>

<script>
export const pageConfig = {
  title: 'Intelligent Manufacturing - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/manufacture.html'
};

import { createApp } from 'vue';
import App from './manufacture.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";

function mountApp() {
  const appNode = document.getElementById('app');
  if (appNode) {
    if (appNode._vueApp) {
      appNode._vueApp.unmount();
      delete appNode._vueApp;
    }
    const app = createApp(App);
    app.use(store);
    appNode._vueApp = app.mount(appNode);
  }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
  module.hot.accept('./manufacture.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss">
// .img-box-height {
//   min-height: 100vh;
// }

.about-first {
  padding: 2.38rem 1.68rem 1.48rem;
  background: radial-gradient(0% 0% at 0% 0%, #F1F1F1 0%, #FFFFFF 100%);

  .about-kv-t1 {
    font-size: 0.56rem;
    color: #000;
    text-align: center;
    margin-bottom: 1rem;
  }

  .about-video-list {
    display: flex;
    gap: 0.5rem;
    justify-content: space-between;
    align-items: center;

    .about-video-item {
      flex: 1;
      overflow: hidden;
      height: 3.87rem;
      border-radius: 0.2rem;
      cursor: pointer;

      .about-video-bottom {
        height: 1rem;
        display: flex;
        padding: 0 0.3rem;
        align-items: center;
        justify-content: space-between;
        background: #fff;

        .about-video-title {
          font-size: 0.28rem;
          color: #000;
        }

        .about-video-play {
          width: 0.3rem;
          height: 0.3rem;
        }
      }
    }
  }
}

.about-full-video {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999;

  .about-full-video-close {
    position: absolute;
    right: 0.5rem;
    top: 0.5rem;
    width: 0.3rem;
    height: 0.3rem;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
    }
  }

}


.about-map-box {
  position: relative;

  .about-map-item {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    .about-map-text {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 1.08rem;
      color: #000;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;


      .about-map-title {
        font-size: 0.5rem;
        font-weight: 500;
        margin-bottom: 0.3rem;
      }

      .about-map-desc {
        font-weight: 300;
        font-size: 0.2rem;
      }

      .about-map-btn-list {
        display: flex;
        gap: 0.11rem;
        justify-content: center;
        align-items: center;
        width: 2.93rem;
        height: 0.52rem;
        background: rgba($color: #002D4C, $alpha: 0.36);
        border-radius: 0.27rem;
        // margin-top: 0.3rem;
        color: #fff;

        .about-map-btn {
          width: 1.3rem;
          height: 0.39rem;
          background: rgba($color: #002D4C, $alpha: 0.37);
          border-radius: 0.2rem;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 0.13rem;
          font-weight: 400;
          cursor: pointer;

          &.active {
            background: linear-gradient(135deg, #E70012 0%, #EA5433 100%);
          }
        }
      }
    }

    .map-hover-box {
      position: absolute;
      color: #000000;
      width: 0;
      height: 0;
      border: #E70012 0.08rem solid;
      border-radius: 0.08rem;
      text-align: center;
      cursor: pointer;
      transition: all 0.5s;
      z-index: 2;

      &::after {
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 0.08rem;
        height: 0.08rem;
        border-radius: 0.08rem;
        background: rgba($color: #E70012, $alpha: 0.21);
        animation: scalePulse 2s linear infinite;
      }

      .img-box {
        width: 0;
        height: auto;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        transition: all 0.5s;
        overflow: hidden;

        img {
          width: 3.66rem;
          height: 1.68rem;
          position: absolute;
          left: 0;
          top: 0;
        }
      }

      &:hover {
        z-index: 77;

        &::before {
          width: 1rem;
        }

        .img-box {
          width: 3.66rem;
          height: 1.68rem;
        }
      }

      .map-hover-box-content {
        display: none;
      }


      &.map-hover-box7 {
        left: 37.7%;
        top: 50%;
        border: #58C1C0 0.05rem solid;

        &::after {
          background: rgba($color: #58C1C0, $alpha: 0.21);
        }
      }

      &.map-hover-box8 {
        left: 38%;
        top: 49.5%;
        border: #E70012 0.05rem solid;
      }

      &.map-hover-box3 {
        left: 37.3%;
        top: 50.8%;
        border: #E70012 0.05rem solid;
      }

      &.map-hover-box9 {
        left: 38%;
        top: 55.4%;
        border: #0052B2 0.05rem solid;

        &::after {
          background: rgba($color: #0052B2, $alpha: 0.21);
        }

      }

      &.map-hover-box10 {
        left: 38.5%;
        top: 49.5%;
        border: #E70012 0.05rem solid;
      }

      &.map-hover-box11 {
        left: 38.5%;
        top: 55%;
        border: #0052B2 0.05rem solid;

        &::after {
          background: rgba($color: #0052B2, $alpha: 0.21);
        }

      }


      &.map-hover-box12 {
        left: 38.5%;
        top: 54%;
        border: #58C1C0 0.05rem solid;

        &::after {
          background: rgba($color: #58C1C0, $alpha: 0.21);
        }
      }

      &.map-hover-box2 {
        left: 38.4%;
        top: 52.4%;
        border: #E70012 0.05rem solid;
      }

      &.map-hover-box13 {
        left: 38%;
        top: 54.5%;
        border: #0052B2 0.05rem solid;

        &::after {
          background: rgba($color: #0052B2, $alpha: 0.21);
        }
      }

      &.map-hover-box14 {
        left: 23%;
        top: 37%;
        border: #E70012 0.05rem solid;

        &::before {
          display: none;
        }
      }

      &.map-hover-box15 {
        left: 35%;
        top: 53.7%;
        border: #58C1C0 0.05rem solid;

        &::after {
          background: rgba($color: #58C1C0, $alpha: 0.21);
        }
      }

      &.map-hover-box5 {
        left: 35.3%;
        top: 54%;
        border: #E70012 0.05rem solid;
      }

      &.map-hover-box4 {
        left: 36.8%;
        top: 54.5%;
        border: #E70012 0.05rem solid;
      }

      &.map-hover-box16 {
        left: 37%;
        top: 56.5%;
        border: #E70012 0.05rem solid;
      }

      &.map-hover-box17 {
        left: 35%;
        top: 60.5%;
        border: #E70012 0.05rem solid;
      }

      &.map-hover-box18 {
        left: 38%;
        top: 52%;
        border: #58C1C0 0.05rem solid;

        &::after {
          background: rgba($color: #58C1C0, $alpha: 0.21);
        }
      }

      &.map-hover-box1 {
        left: 38%;
        top: 53.3%;
        border: #E70012 0.05rem solid;
      }

      &.map-hover-box19 {
        left: 38.5%;
        top: 51.5%;
        border: #58C1C0 0.05rem solid;

        &::after {
          background: rgba($color: #58C1C0, $alpha: 0.21);
        }
      }

      &.map-hover-box6 {
        left: 26%;
        top: 42%;
        border: #E70012 0.05rem solid;
      }

    }

  }

  .map-detail-box {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 88;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 17rem;
    height: auto;

    .map-detail-d {
      display: flex;
      justify-content: space-between;
      width: 16.1rem;
      background: #F1F1F1;
      border: 1px solid #060100;
      border-radius: 0.2rem;
      overflow: hidden;

      .map-detail-left {
        width: 7rem;
      }

      .map-detail-right {
        padding: 0.26rem 0.46rem;
        width: 8rem;

        .map-right-top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 0.8rem;
          position: relative;

          &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: -0.4rem;
            width: 0.52rem;
            height: 0.02rem;
            background: #E70012;
          }

          .map-detail-name {
            font-weight: 600;
            font-size: 0.28rem;
          }

          .map-detail-address {
            display: flex;
            align-items: center;
            gap: 0.1rem;
            font-weight: 300;
            font-size: 0.22rem;
            text-wrap: nowrap;

            img {
              width: 0.19rem;
              height: auto;
            }
          }
        }

        .map-right-bottom {
          font-weight: 300;
          font-size: 0.17rem;
          // line-height: 0.34rem;
        }
      }
    }

    .map-detail-icon {
      width: 0.37rem;
      height: auto;
      cursor: pointer;

      img {
        width: 100%;
        height: auto;
        object-fit: cover;
      }
    }

  }
}

.culture-master {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0.5rem;
  width: 80% !important;
  height: auto;
  object-fit: cover;
}


@keyframes scalePulse {
  0% {
    width: 0.08rem;
    height: 0.08rem;
    border-radius: 0.08rem;
    opacity: 1;
  }

  100% {
    width: 0.32rem;
    height: 0.32rem;
    border-radius: 0.32rem;
  }
}

@media (max-width: 768px) {
  .about-first {
    padding: 1rem 0.45rem;

    .about-kv-t1 {
      font-size: 0.5rem;
    }

    .about-video-list {
      flex-direction: column;

      .about-video-item {
        .about-video-bottom {
          background: #F4F4F4;

          .about-video-title {
            font-size: 0.32rem;
          }
        }
      }
    }
  }

  .about-map-box {
    .about-map-item {
      .about-map-text {
        top: 1.23rem;
        width: 5.68rem;

        .about-map-btn-list {
          display: flex;
          gap: 0.11rem;
          justify-content: center;
          align-items: center;
          width: 6.5rem;
          height: 0.68rem;
          background: rgba($color: #002D4C, $alpha: 0.12);
          border-radius: 0.34rem;
          color: #fff;

          .about-map-btn {
            width: 1.9rem;
            height: 0.52rem;
            background: rgba($color: #fff, $alpha: 0.3);
            border-radius: 0.26rem;
            color: #002D4C;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 0.16rem;
            font-weight: 400;
            cursor: pointer;
            gap: 0.05rem;

            div {
              width: 0.1rem;
              height: 0.1rem;
              border-radius: 50%;
            }

            &.active {
              background: #fff;
            }
          }
        }
      }

      .map-hover-box {
        .map-hover-box-content {
          display: flex;
          gap: 0.05rem;
          width: auto;
          position: absolute;

          .map-hover-box-title {
            font-size: 0.17rem;
            width: 2.3rem;
            height: 30px;
          }

          &.lt {
            right: 0;
            bottom: 0;
          }

          &.rt {
            left: 0;
            bottom: 0;
          }

          &.rb {
            left: 0;
            top: 0;
            align-items: flex-end;
            .map-hover-box-title{
              transform: translateY(50%);
            }
          }

          &.lb {
            right: 0;
            top: 0;
            align-items: flex-end;
            .map-hover-box-title{
              transform: translateY(50%);
            }
          }
        }

        &.map-hover-box10 {
          left: 53.5%;
          top: 54.5%;
        }

        &.map-hover-box8 {
          left: 50%;
          top: 54.5%;
          z-index: 6;

        }

        &.map-hover-box3 {
          left: 47.3%;
          top: 55.8%;
          z-index: 7;
        }

        &.map-hover-box2 {
          left: 54.4%;
          top: 57.4%;
        }

        &.map-hover-box1 {
          left: 52%;
          top: 58.3%;
        }

        &.map-hover-box4 {
          left: 48.8%;
          top: 59.3%;
          z-index: 8;
          .map-hover-box-title{
            width: 3rem;
          }
        }

        &.map-hover-box5 {
          left: 44.3%;
          top: 59%;
          z-index: 9;
        }

        &.map-hover-box16 {
          left: 49%;
          top: 61%;
        }

        &.map-hover-box17 {
          left: 45%;
          top: 64.5%;
        }

        &.map-hover-box6 {
          left: 20%;
          top: 45%;
        }


        // 变速器工厂

        &.map-hover-box7 {
          left: 50.7%;
          top: 55%;
        }

        &.map-hover-box19 {
          left: 54.5%;
          top: 57.5%;
        }

        &.map-hover-box18 {
          left: 52%;
          top: 58%;
        }

        &.map-hover-box12 {
          left: 55.5%;
          top: 59%;
        }

        &.map-hover-box15 {
          left: 48%;
          top: 58.7%;
        }


        // 电子工厂
        &.map-hover-box13 {
          left: 53%;
          top: 57.5%;
        }

        &.map-hover-box11 {
          left: 55.5%;
          top: 59%;
        }

        &.map-hover-box9 {
          left: 53%;
          top: 59.4%;
        }
      }


      // &.map-hover-box9,
      // &.map-hover-box10,

    }

    .map-detail-box {
      width: 6.6rem;
      flex-direction: column;
      align-items: center;
      gap: 0.2rem;

      .map-detail-d {
        flex-direction: column;
        width: 6.6rem;

        .map-detail-right {
          padding: 0.45rem 0.3rem;
          width: calc(100% - 0.6rem);
        }

        .map-detail-left {
          width: 100%;
        }
      }
    }
  }

  .about-full-video {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #000;

    .about-full-video-close {
      width: 0.6rem;
      height: 0.6rem;
    }
  }
}
</style>